import { DeliveryTypeEnum } from "@saleor/types/globalTypes";
import { defineMessages, useIntl } from "react-intl";

import { ExpressFleetUpdate, isExpressFleetUpdate } from "./expressFleetUtils";
import { isLocationRateUpdate, LocationRateUpdate } from "./locationRateUtils";
import { isPriceRateUpdate, PriceRateUpdate } from "./priceRateUtils";

export const parseNewValues = (
  raw: string,
  type: "PRICE" | "LOCATION" | "EXPRESS_FLEET"
): LocationRateUpdate | PriceRateUpdate | ExpressFleetUpdate => {
  let parsed: any = raw;

  try {
    if (typeof parsed === "string") {
      parsed = JSON.parse(parsed);
    }
    if (typeof parsed === "string") {
      parsed = JSON.parse(parsed);
    }

    if (type === "PRICE" && isPriceRateUpdate(parsed)) {
      return parsed;
    }
    if (type === "LOCATION" && isLocationRateUpdate(parsed)) {
      return parsed;
    }
    if (type === "EXPRESS_FLEET" && isExpressFleetUpdate(parsed)) {
      return parsed;
    }

    return parsed;
  } catch (err) {
    console.error("Failed to parse newValues:", err);
    throw err;
  }
};

export const isStatusFieldUpdated = (params: any[]): boolean =>
  params.some(
    param => "status" in (param.old || {}) || "status" in (param.new || {})
  );

const messages = defineMessages({
  expressDelivery: {
    defaultMessage: "Express Delivery",
    description: "express delivery"
  },
  expressLongDistance: {
    defaultMessage: "10km Express Delivery",
    description: "expressLongDistance"
  },
  inStore: {
    defaultMessage: "In Store Pickup",
    description: "in store pickup"
  },
  nationwide: {
    defaultMessage: "Nationwide Delivery",
    description: "nationwide delivery"
  },
  nextDay: {
    defaultMessage: "Standard Delivery",
    description: "standard delivery"
  },
  sameDay: {
    defaultMessage: "Same Day Delivery",
    description: "same day delivery"
  }
});

export const convertStringDeliveryType = (delTypeStr: string) => {
  const delType = Object.values(DeliveryTypeEnum).find(
    type => type.toUpperCase() === delTypeStr.toUpperCase()
  );

  const intl = useIntl();
  switch (delType) {
    case DeliveryTypeEnum.EXPRESS:
      return intl.formatMessage(messages.expressDelivery);
    case DeliveryTypeEnum.EXPRESS_LONG_DISTANCE:
      return intl.formatMessage(messages.expressLongDistance);
    case DeliveryTypeEnum.IN_STORE_PICKUP:
      return intl.formatMessage(messages.inStore);
    case DeliveryTypeEnum.NATIONWIDE_DELIVERY:
      return intl.formatMessage(messages.nationwide);
    case DeliveryTypeEnum.NEXT_DAY:
      return intl.formatMessage(messages.nextDay);
    case DeliveryTypeEnum.SAME_DAY:
      return intl.formatMessage(messages.sameDay);
    default:
      return "";
  }
};
